export const NAME = 'transaction'
export const SET_TRANSACTIONS = 'SET_TRANSACTIONS'